/**
 * The site's animated parrot (design "Tooti Web": the download section's
 * white bird and the scroll guide's blue one). Same geometry as
 * ParrotMark, minus the feet, with the wing flapping and the eye blinking
 * — the two `@keyframes` live in index.css. `variant="white"` is the bird
 * on the brand-gradient band; `"blue"` is the brand-coloured one.
 */
export default function Mascot({ size = 104, variant = 'blue', className }) {
  const white = variant === 'white'
  const body = white ? '#FFFFFF' : '#2A5C99'
  const tail = white ? '#8FBBEC' : '#2A5C99'
  const beak = white ? '#F2BE1A' : '#F5C518'
  const beakDeep = white ? '#C4970B' : '#E0AE13'
  return (
    // The drawing spans x 14–150, y 24–180, so its centre is (82, 102), not
    // (100, 100): the viewBox is moved onto it, otherwise the bird sits
    // left of centre in the round guide bubble.
    <svg width={size} height={size} viewBox="-18 2 200 200" aria-hidden="true" className={className}>
      <path d="M66 116 C64 146 48 168 22 180 C16 171 14 165 16 159 C40 147 52 133 58 110 Z" fill={tail} />
      <rect x="52" y="24" width="62" height="128" rx="31" fill={body} />
      <ellipse cx="84" cy="124" rx="41" ry="40" fill={body} />
      <path d="M112 50 A38 38 0 0 1 150 88 L112 88 Z" fill={beak} />
      <path d="M112 88 L146 88 A26 26 0 0 1 114 104 Z" fill={beakDeep} />
      {/* Hinged at the shoulder (the wing's rounded front, beak side), so the
          pointed tip is what lifts — not the other way round. */}
      <g style={{ transformOrigin: '106px 110px', animation: 't-wing 1.5s ease-in-out infinite' }}>
        <path d="M40 142 C43 112 70 90 98 97 C122 103 122 130 102 145 C82 160 55 158 40 142 Z" fill={beakDeep} />
        <path d="M45 138 C50 113 72 95 96 102 C116 108 116 127 99 141 C80 155 59 152 45 138 Z" fill={beak} />
      </g>
      <g style={{ transformOrigin: '94px 64px', animation: 't-blink 4.2s ease-in-out infinite' }}>
        <circle cx="94" cy="64" r="21" fill="#FFFFFF" />
        <circle cx="94" cy="64" r="15" fill="#1B3A66" />
        <circle cx="100" cy="57" r="4.5" fill="#FFFFFF" />
      </g>
    </svg>
  )
}
